import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-list__item-title" }
const _hoisted_2 = { class: "custom-list__item-text" }

import { CustomListItem } from '@/types/common/CustomList';

    interface WindowHouse {
        list?: Array<CustomListItem>;
        theme?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomList',
  props: {
    list: { default: () => [] },
    theme: { default: 'odd' }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_ctx.list.length)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: _normalizeClass(["custom-list", `custom-list--${_ctx.theme}`])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "custom-list__item",
            key: item.id
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(item.text), 1)
          ]))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})